import { api } from '../../DefaultService';
import { ITuyaCreateProps, ITuyaUpdateParams } from './types';

const ENDPOINT = '/v1/integrations/tuya';

export const createTuyaIntegrationAsync = async (data: ITuyaCreateProps) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateTuyaIntegrationAsync = async ({
  id,
  data,
}: ITuyaUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteTuyaIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const getTuyaIntegrationByIdAsync = async (id: number) => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
